import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import arbitrageIcon from "../assets/images/arbitrage.svg";
import newStatus from "../assets/icons/new_status_tag.svg";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ArbitrageHistory } from "./ArbitrageHistory";
import { InvestmentCarousel } from "./InvestmentCarousel";
import { SearchIcon } from "lucide-react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import info from "../assets/icons/info_icon.svg";
import arbIcon from "../assets/icons/arb-payout.svg";

export default function ArbitrageOverview() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState(null);
  const [open1, setIsOpen1] = useState(true);
  const [open2, setIsOpen2] = useState(false);
  const [open3, setIsOpen3] = useState(false);

  return (
    <div className="col-span-4 px-8">
      <div className="py-4 mb-2">
        <Card className="bg-white rounded-2xl shadow-sm pt-10 pb-5 mb-4">
          <CardHeader className="mb-4  px-20">
            <div className="flex justify-between items-center px-6 py-6 bg-bg-neutral/30 rounded-[15px]">
              <div className="flex items-center gap-4">
                <div>
                  <img src={arbIcon} alt="" />
                </div>
                <div>
                  <div className="text-text-primary text-[20px] font-semibold">
                    Payout
                  </div>
                  <div className="text-gray-500 text-sm">Today, 11:30 AM</div>
                </div>
              </div>
              <div>
                <div className="flex justify-end text-[20px] text-text-primary font-semibold">
                  R 590.89
                </div>
              </div>
            </div>
          </CardHeader>
          <CardContent className="px-20 pb-8 outline outline-gray-50 rounded-lg outline-1">
            <div className="mb-2">
              <h4 className="text-[14px] text-text-secondary font-semibold mb-2">
                Transaction details
              </h4>
              <div className="">
                <div className="flex items-center justify-between px-3 py-3 border rounded-t-lg">
                  <p className="text-[14px] text-text-primary font-normal">
                    Amount paid out
                  </p>
                  <p className="text-[16px] text-text-primary font-semibold">
                    R 10 124.56
                  </p>
                </div>
                <div className="flex items-center justify-between px-3 py-3 border-r border-l border-b">
                  <p className="text-[14px] text-text-primary font-normal">
                    Status
                  </p>
                  <p className="text-[16px] text-text-primary font-semibold">
                    Successful
                  </p>
                </div>
                <div className="flex items-center justify-between px-3 py-1 border-r border-l border-b">
                  <p className="text-[14px] text-text-primary font-normal">
                    Time stamp
                  </p>
                  <div>
                    <p className="text-[16px] text-text-primary font-semibold text-right">
                      3 Feb 2024
                    </p>
                    <p className="text-[14px] text-text-secondary font-normal">
                      15:00:31 GMT+0200
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between px-3 py-3 border-r border-l border-b">
                  <p className="text-[14px] text-text-primary font-normal">
                    Transaction ID
                  </p>
                  <p className="text-[16px] text-text-primary font-semibold">
                    d6ee6c...3b4a
                  </p>
                </div>
                <div className="flex items-center justify-between px-3 py-3 border-r border-l">
                  <div className="flex">
                    <p className="text-[14px] text-text-primary font-normal mr-2">
                      Service charge
                    </p>
                    <img src={info} alt="" />
                  </div>
                  <p className="text-[16px] text-text-primary font-semibold">
                    R 8.00
                  </p>
                </div>
                <div className="flex items-center justify-between px-3 py-3 border rounded-b-lg">
                  <p className="text-[14px] text-text-primary font-semibold">
                    Total cost
                  </p>
                  <p className="text-[16px] text-text-primary font-semibold">
                    R 598.89
                  </p>
                </div>
              </div>
            </div>
          </CardContent>

          <Separator />
          <div className="flex justify-center pt-7 pb-4">
            <p className="text-sm text-gray-500 mr-2">Questions? </p>
            <a
              className="font-bold text-rose-500 hover:underline"
              onClick={() => {
                navigate("/support/whatsapp");
              }}
            >
              Contact us
            </a>
          </div>
        </Card>
      </div>
    </div>
  );
}
